<template>
  <v-dialog
    persistent
    v-model="isVisible"
    max-width="512"
  >
    <v-card>
      <v-card-title class="headline">
        <span>{{ isNewOffer ? $i18n.t('offer.parcels.createOffer'): $i18n.t('dialog.header.addingProject') }}</span>
      </v-card-title>
      <v-form
        ref="form"
        v-model="isValid"
        @submit.prevent="save"
        id="form--main"
      >
        <v-card-text>
          <template>
            <v-row no-gutters>
              <v-col
                cols="12"
                xs="12"
              >
                <v-text-field
                  outlined
                  v-model="title.pl"
                  :rules="rules"
                  :label="$i18n.t('default.titlePL')"
                  required
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col
                cols="12"
                xs="12"
              >
                <v-text-field
                  outlined
                  v-model="title.en"
                  :rules="rules"
                  :label="$i18n.t('default.titleEN')"
                  required
                />
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            text
            @click="close"
          >{{ $i18n.t('dialog.confirmation.close') }}</v-btn>
          <v-btn
            color="primary"
            text
            :title="$i18n.t('dialog.confirmation.save')"
            type="submit"
            form="form--main"
            :loading="creating"
          >{{ $i18n.t('dialog.confirmation.save') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    ids: {
      required: true,
      type: Array
    },
    isVisible: {
      required: true,
      type: Boolean
    },
    isNewOffer: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    title: {
      en: '',
      pl: ''
    },
    isValid: false,
    creating: false
  }),
  computed: {
    rules() {
      return [
        v => !!v || this.$i18n.t('default.ruleNoEmpty'),
        v => v.length <= 28 || this.$i18n.t('default.shorterThan')
      ];
    }
  },
  methods: {
    close() {
      this.$emit('close');
      this.title = {
        en: '',
        pl: ''
      };
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.isNewOffer) {
          this.creating = true;
          this.$store
            .dispatch('postOfferFromParcels', {
              pl: this.title.pl,
              en: this.title.en,
              ids: this.ids
            })
            .then(r => {
              this.creating = false;
              if (r.status === 201) {
                if (r.data.here_api_error) {
                  this.$root.$emit('showSnackbar', this.$i18n.t(`default.warningHere`));
                }
                this.$router.push({
                  name: 'offer',
                  params: { id: r.data.offer }
                });
              } else if (r.status === 503) {
                this.$root.$emit(
                  'showSnackbar',
                  this.$i18n.t(`default.errorHere`)
                );
              } else {
                this.$root.$emit('showSnackbar', this.$i18n.t(`default.error`));
              }
            })
            .catch(e => {
              this.creating = false;
              console.error(e);
              if (e.response && e.response.data && e.response.data.error) {
                this.$root.$emit('showSnackbar', e.response.data.error);
              } else {
                this.$root.$emit('showSnackbar', this.$i18n.t(`default.error`));
              }
            });
        } else {
          this.$store
            .dispatch('postProject', {
              pl: this.title.pl,
              en: this.title.en,
              pl_desc: '',
              en_desc: '',
              offers: this.ids
            })
            .then(r => {
              if (r.status === 201) {
                this.$router.push({
                  name: 'project',
                  params: { id: r.data.projects }
                });

                // this.$emit('addedProject', {
                //   id: r.data.projects,
                //   title: this.title
                // });
              }
              this.title = {
                en: '',
                pl: ''
              };
            });
        }
      }
    }
  }
};
</script>

<style></style>
